import { useToast } from '@chakra-ui/react';
import { useCallback } from 'react';

import { trpc } from '../../config/trpc';

export const useProviderBookingConfirmation = () => {
  const { mutateAsync, isLoading } = trpc.setProviderBookingConfirmation.useMutation();
  const toast = useToast();

  const setConfirmation = useCallback(
    async (quoteId: number | undefined, isConfirmed: boolean) => {
      if (!quoteId) return;

      try {
        await mutateAsync({ quoteId, isConfirmed });
      } catch (error) {
        toast({
          title: 'Could not update the carrier confirmation',
          description: (error as Error)?.message,
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        throw error;
      }
    },
    [mutateAsync, toast],
  );

  return { setConfirmation, isLoading };
};
